// deployment_class: customer_env_allowed
/**
 * Personal-tier surface registrations (Settings & Account IA spec 2026-06-24,
 * zone `settings.personal` → `/account/*`). Tier 1 is visible to every
 * authenticated user (identity scopes), so these surfaces carry no
 * `requiredScope`.
 *
 * The shipped, polished `ProfileScreen` + `SettingsScreen` (Tier-A polish,
 * commit 7b40463) are REUSED VERBATIM — registered as surfaces via lazy loaders
 * that map their named exports to the default the registry expects. Zero visual
 * setback; the registry simply composes them.
 *
 * Registration is an explicit function (not an import side-effect) so it is
 * deterministic + testable: the app calls it once at startup; tests call it
 * after `clearSurfaces()`.
 */
import { registerSurface, getSurfaces } from '../csa-surface/registry';

export function registerPersonalSurfaces(): void {
  // Idempotent: skip if already registered (StrictMode double-invoke / HMR).
  if (getSurfaces('settings.personal').length > 0) return;

  registerSurface({
    id: 'profile',
    zone: 'settings.personal',
    label: 'Profile',
    order: 10,
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./ProfileScreen').then((m) => ({ default: m.ProfileScreen })),
  });

  registerSurface({
    id: 'preferences',
    zone: 'settings.personal',
    label: 'Preferences',
    order: 20,
    deploymentClass: 'customer_env_allowed',
    component: () =>
      import('./SettingsScreen').then((m) => ({ default: m.SettingsScreen })),
  });
}
